import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { FormattedDate } from 'components/intl'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { FormData, Status, Button } from 'components/misc'

export default class AssessorDetailModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
  }

  static defaultProps = {
    data: {}
  }

  render() {
    const { modalId, data } = this.props

    return (
      <Modal id={modalId} customActions>
        <Title h2 intlKey="moduleTitle.assessor_details">
          Assessor details
        </Title>
        <div className="row">
          <div className="col-xs-6">
            <FormData label="First Name" intlKey="label.first_name">
              {get(data, 'firstName') || get(data, 'assessor.person.firstName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Last Name" intlKey="label.last_name">
              {get(data, 'lastName') || get(data, 'assessor.person.lastName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Email" intlKey="label.email">
              {get(data, 'email') || get(data, 'assessor.person.email')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Birthday" intlKey="label.birthdate">
              {get(data, 'birthDate') ? (
                <FormattedDate value={data.birthDate} />
              ) : (
                get(data, 'assessor.person.birthDate')
              )}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Phone" intlKey="label.phone">
              {get(data, 'phoneNumber') || get(data, 'assessor.person.phone')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Phone type" intlKey="label.phone_type">
              {get(data, 'phoneType.translationText') ||
                get(data, 'assessor.person.firstName')}
            </FormData>
          </div>

          <div className="col-xs-6">
            <FormData label="Organization" intlKey="label.organization">
              {get(data, 'assessor.organization.name')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Coordinator" intlKey="label.coordinator">
              <Status
                state={Boolean(get(data, 'isCoordinator'))}
                check
                inline
                noWaiting
              />
            </FormData>
          </div>

          <div className="col-xs-6">
            <FormData
              label="Child protection number"
              intlKey="label.child_protection_number"
            >
              {get(data, 'childProtectionNumber')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData
              label="Child protection number"
              intlKey="label.wwc_expired"
            >
              {get(data, 'childProtectionExpirationDate') && (
                <FormattedDate value={get(data, 'childProtectionExpirationDate')} />
              )}
            </FormData>
          </div>

          <div className="col-xs-6">
            <FormData
              label="Previously worked as Assessor"
              intlKey="label.previously_worked_as_assessor"
            >
              <Status
                state={Boolean(get(data, 'workExperienceLength'))}
                check
                inline
                noWaiting
              />
            </FormData>
          </div>
          {Boolean(get(data, 'workExperienceLength')) && (
            <div className="col-xs-6">
              <FormData label="Experience" intlKey="label.experience">
                {get(data, 'experience')}
              </FormData>
            </div>
          )}
        </div>

        <Title h2 intlKey="moduleTitle.address">
          Address
        </Title>

        <div className="row">
          <div className="col-xs-12">
            <FormData label="Address Line 1" intlKey="label.addressLine1">
              {get(data, 'line1') ||
                get(data, 'assessor.person.address.line1') ||
                '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Address Line 2" intlKey="label.addressLine2">
              {get(data, 'line2') ||
                get(data, 'assessor.person.address.line2') ||
                '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Post Code" intlKey="label.post_code">
              {get(data, 'zipCode') ||
                get(data, 'assessor.person.address.zipCode') ||
                '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="State/Province/Region" intlKey="label.state_province">
              {get(data, 'stateOrProvinceOrRegion') ||
                get(data, 'assessor.person.address.stateOrProvinceOrRegion') ||
                '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Post Code" intlKey="label.country">
              {get(data, 'country.name') ||
                get(data, 'assessor.person.address.country.name') ||
                '---'}
            </FormData>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text--right">
            <Button
              type="button"
              intlKey="button.close"
              onClick={() => this.props.modal(null)}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}
